import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@utils';

export const useRetrieveDeclarantLogo = (declarantId: string, enabled: boolean) => {
  return useQuery({
    queryKey: ['declarant-logo', declarantId],
    enabled: enabled,
    queryFn: async () => {
      const result = await apiClient.declarant.getLogo.query({ params: { declarantId } });
      if (result.status !== 200) throw result.body;

      const { base64, fileName } = result.body.data;

      const mimeType = fileName.toLowerCase().includes('jpeg') || fileName.toLowerCase().includes('jpg') ? 'image/jpeg' : 'image/png';

      const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

      const blob = new Blob([bytes], { type: mimeType });

      return await new Promise<string>((resolve) => {
        const reader = new FileReader();

        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });
    },
  });
};
